import React from 'react';
import { DownFill } from 'antd-mobile-icons';
import classNames from 'classnames';

import './index.scss';
import dataFormat from '@home/utils/dbDataFormat/dataFormat';

interface RateSlotNewType {
  className?: string;
  rate: number | string;
  permission?: boolean;
  hasPlaceholder?: boolean;
  formatRule?: string;
}

function isEmptyRate(val: string | number | undefined | null) {
  return val === '' || val === undefined || val === null;
}

export default function RateSlotNew(props: RateSlotNewType) {
  const {
    className = '',
    rate,
    permission = true,
    hasPlaceholder = true,
    formatRule = 'absPercentIntMax',
  } = props;

  if (!permission) {
    return <div className="rate-text">**</div>;
  }

  let rateType = 'none';

  if (Number(rate) < 0) {
    rateType = 'down';
  } else if (Number(rate) > 0) {
    rateType = 'up';
  }

  let value: string | number = '-';

  if (!isEmptyRate(rate)) {
    value = dataFormat({ value: rate, formatRule });
    if (parseFloat(String(value)?.replace(/[^0-9.]/g, '')) === 0) {
      rateType = 'none';
    }
  }

  return (
    <div className={classNames('rate-text', className, `rate-${rateType}`)}>
      {hasPlaceholder ? (
        <div className="rate-icon">
          <DownFill />
        </div>
      ) : (
        <>
          {!isEmptyRate(rate) && (
            <div className="rate-icon">
              <DownFill />
            </div>
          )}
        </>
      )}

      <div>{value}</div>
    </div>
  );
}
